import { useVehicleLedgerInvoices } from "../vehicle_ledger/useVehicleLedgerInvoices";
import { useVehicleLedgerDefaults } from "../vehicle_ledger/useVehicleLedgerDefaults";
import { useVehicleLedgerSearch } from "../vehicle_ledger/useVehicleLedgerSearch";
import { useVehicleLedgerAdvance } from "../vehicle_ledger/useVehicleLedgerAdvance";
import { useVehicleLedgerStickers } from "../vehicle_ledger/useVehicleLedgerStickers";
import { useVehicleLedgerReceipts } from "../vehicle_ledger/useVehicleLedgerReceipts";

// Handle vehicle ledger tabs configuration
export const vehicleLedgerHooks: Record<string, any> = {
  receipts: useVehicleLedgerReceipts,
  invoices: useVehicleLedgerInvoices,
  defaults: useVehicleLedgerDefaults,
  search_vehicle: useVehicleLedgerSearch,
  advance: useVehicleLedgerAdvance,
  stickers: useVehicleLedgerStickers,
};

// Tab configuration for the vehicle ledger modal
export const vehicleLedgerTabs = [
  { key: "search_vehicle", label: "Search Vehicle" },
  { key: "receipts", label: "Receipts" },
  { key: "invoices", label: "Invoices" },
  { key: "defaults", label: "Defaulted" },
  { key: "advance", label: "Advance" },
  { key: "stickers", label: "Stickers" },
];
